import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'

import BaseModal from '../BaseModal2'
import TextRow from '../BaseModal/TextRow'
import Button from '../../../atoms/Button2'

import { useUserAPI } from '../../../../providers/UserAPIProvider'
import { useAreYouSure } from '../../../../providers/AreYouSureProvider'
import { useEnvironment } from '../../../../providers/EnvironmentProvider'
import { selectRole } from '../../../../slices/role'
import { AddSuccessAlert } from '../../../../slices/alert'
import useStyles from './styles'

const startingVals = {
  name: '',
  email: ''
}

const AddUserModal = ({ open, onClose, cb, hideInternal, ...props }) => {
  const dispatch = useAppDispatch()
  const roleSelector = useAppSelector(selectRole)
  const {
    setAction: setCloseAction,
    setReason: setCloseReason,
    setV2
  } = useAreYouSure()
  const { uploadUser } = useUserAPI()
  const { getEnvValue } = useEnvironment()
  const { adminRole } = roleSelector

  const [values, setValues] = React.useState(startingVals)
  const [changed, setChanged] = React.useState(false)
  const [saving, setSaving] = React.useState(false)
  const invalid = values.email === '' || values.name === ''
  const classes = useStyles(props)

  const closeAndClear = () => {
    onClose()
    setValues(startingVals)
    setChanged(false)
    setSaving(false)
  }

  const handleClose = () => {
    const action = closeAndClear

    if (changed) {
      setV2(true)
      setCloseReason('Are you sure you want to close this modal?')
      setCloseAction(action)
    } else {
      action()
    }
  }

  const handleChange = prop => e => {
    let val = e.target.value
    if (prop === 'email') {
      val = val.trim().replaceAll(' ', '')
    }
    setValues(vals => ({ ...vals, [prop]: val }))
    setChanged(true)
  }

  const handleSubmit = async () => {
    try {
      setSaving(true)
      const type_id =
        getEnvValue('config.users', 'u_default_internal_type_id', null) ??
        getEnvValue('config.users', 'users_default_internal_type_id', null)

      const data = {
        ...values,
        role_id: adminRole?.id ?? null,
        status_id: null,
        avatar_id: null,
        channels: [],
        type_id
      }

      await uploadUser(
        data,
        false,
        () => {
          dispatch(AddSuccessAlert('User created'))
          cb && cb()
          closeAndClear()
        },
        null,
        () => {
          setSaving(false)
        }
      )
    } catch (error) {
      console.error('Error creating user.', error)
    }
  }

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      title='ADD USER'
      PaperProps={{ style: { top: '53%', width: '38%' } }}
      {...props}
    >
      <TextRow title='Name' className={classes.row}>
        <input
          autoFocus
          value={values.name}
          onChange={handleChange('name')}
          className={classes.input}
        />
      </TextRow>

      <TextRow title='Email' className={classes.row}>
        <input
          value={values.email}
          onChange={handleChange('email')}
          className={classes.input}
        />
      </TextRow>

      <div className={classes.controls}>
        <Button onClick={closeAndClear} className={classes.button}>
          CANCEL
        </Button>

        <Button
          onClick={handleSubmit}
          className={classes.button}
          loading={saving}
          disabled={invalid}
        >
          ADD USER
        </Button>
      </div>
    </BaseModal>
  )
}

export default AddUserModal
